import React from "react";
import { Event } from "@uno/protocol";
import { AppContext } from "context";
import { useSounds } from "context/SoundContext";

export const emoteEventBus = new EventTarget();

export type EmoteEvent = {
    playerId: string;
    emoteId: string;
};

const useRoomEmoteListener = () => {
    const { socket } = React.useContext(AppContext);
    const { play } = useSounds();

    React.useEffect(() => {
        if(!socket) {
            return;
        }

        const handler = (payload: EmoteEvent) => {
            emoteEventBus.dispatchEvent(new CustomEvent("emote", { detail: payload }));
            play("notification");
        };

        socket.on(Event.RoomPlayerPutEmote, handler);

        return () => {
            socket.off(Event.RoomPlayerPutEmote, handler);
        };
    }, [socket]);
};

export default useRoomEmoteListener;
